import { render, staticRenderFns } from "./consultAdd.vue?vue&type=template&id=0c2a539a"
import script from "./consultAdd.vue?vue&type=script&lang=js"
export * from "./consultAdd.vue?vue&type=script&lang=js"
import style0 from "./consultAdd.vue?vue&type=style&index=0&id=0c2a539a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports